import '.ah{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.h6{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.ao{align-items:flex-start;}.ssr-plugin'
import '.dd{padding:2rem;}.ssr-plugin'
import '.dw{background:var(--palette-white);}.ssr-plugin'
import '.bq{overflow:hidden;}.ssr-plugin'
import '.b6{position:absolute;}.ssr-plugin'
import '.jm{top:50%;}.ssr-plugin'
import '.jn{right:1rem;}.ssr-plugin'
import '.jo{transform:translateY(-50%);}.ssr-plugin'
import '.jp{width:120px;}.ssr-plugin'
import '.jq{height:120px;}.ssr-plugin'
import '.jr{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.j2{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.js{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jt{font-size:4rem;}.ssr-plugin'
import '.d7{font-weight:700;}.ssr-plugin'
import '.ju{line-height:100%;}.ssr-plugin'
import '.gu{margin:0px;}.ssr-plugin'
import '.a1{color:var(--brand-secondary);}.ssr-plugin'
import '.a2{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ah n h6 d e ab ao dd dw bq"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b6 jm jn jo jp jq jr d r ab"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ah j2 d e ao s js"
      >
        <div className="jt d7 ju gu a1 a2"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
